export default "__VITE_ASSET__DS5cD76___"